import { RULES_CONSTANT } from 'constant/RuleConstant';
import { RuleParameterOption, RuleParameterSchemaItem, RuleParameterValues } from '../types';

function splitSavedIds(ruleTypeParamsId?: string | null) {
  return (ruleTypeParamsId || '').split(',').filter(Boolean);
}

function getSavedOption(persistentName: string, savedIdEntry?: string): RuleParameterOption {
  const separatorIndex = savedIdEntry?.indexOf('=') ?? -1;
  const savedId = separatorIndex >= 0 ? savedIdEntry?.slice(separatorIndex + 1) : savedIdEntry;
  return {
    label: persistentName,
    persistentName,
    value: savedId || persistentName,
  };
}

export function hydrateParameterValues(
  schema: RuleParameterSchemaItem[],
  ruleTypeParams?: string | null,
  ruleTypeParamsId?: string | null,
  ruleTypeCode?: string
): RuleParameterValues {
  if (!ruleTypeParams) return {};

  if (ruleTypeCode === RULES_CONSTANT.TEXT.RULE_CONCATENATE_ATTRIBUTES) {
    try {
      const parsed = JSON.parse(ruleTypeParams);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
    } catch {
      // Legacy concatenate definitions use the normal comma-separated representation.
    }
  }

  const scoreMappingField = schema.find((field) => field.type === 'score-mapping-table');
  let params = ruleTypeParams.split(',');
  let scoreMappingValue: string | undefined;
  if (scoreMappingField) {
    const scoreMappingMatch = ruleTypeParams.match(/\[.*\]/);
    scoreMappingValue = scoreMappingMatch?.[0];
    if (scoreMappingValue) params = ruleTypeParams.slice(0, ruleTypeParams.indexOf(scoreMappingValue)).split(',');
  }

  const savedIds = splitSavedIds(ruleTypeParamsId);
  return schema.reduce<RuleParameterValues>((values, field, index) => {
    if (field.type === 'score-mapping-table') {
      values[field.id] = scoreMappingValue || '[]';
    } else if (field.type === 'dropdown' || field.type === 'dropdown-dynamic') {
      let persistentName = params[index] || '';
      if (
        ruleTypeCode === RULES_CONSTANT.TEXT.RULE_SELECT_FROM_KTREE_TABLE &&
        field.id === 'KTREE' &&
        savedIds[index]?.includes('=')
      ) {
        persistentName = savedIds[index].slice(0, savedIds[index].indexOf('='));
      }
      values[field.id] = persistentName ? getSavedOption(persistentName, savedIds[index]) : '';
    } else {
      values[field.id] = params[index] ?? field.defaultValue ?? '';
    }
    return values;
  }, {});
}

export function countSavedParameters(ruleTypeParams?: string | null, ruleTypeCode?: string) {
  if (!ruleTypeParams) return 0;
  if (ruleTypeCode === RULES_CONSTANT.TEXT.RULE_CONCATENATE_ATTRIBUTES) {
    try {
      const parsed = JSON.parse(ruleTypeParams);
      return parsed && typeof parsed === 'object' ? Object.keys(parsed).length : 0;
    } catch {
      // Fall through for legacy data.
    }
  }
  return ruleTypeParams.split(',').length;
}
